<div
  class="viewer-root"
  [class.viewer-root--embedded]="isComponent"
>
  <div class="viewer-viewport">
    @if (safePdfUrl) {
      <iframe
        class="viewer-pdf"
        [src]="safePdfUrl"
        [title]="pdfTitle || translations.pdfFallbackTitle"
      ></iframe>
    } @else {
      <div class="viewer-empty">{{ translations.noPdfAvailable }}</div>
    }
  </div>
</div>
